<template>
  <textarea 
    class="app-textarea" 
    v-bind="$attrs" 
    v-on="inputListeners"
    :value="value"
  ></textarea>
</template>

<script>
export default {
  name: 'AppTextarea',
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Number],
      default: ''
    }
  },
  computed: {
    inputListeners() {
      const vm = this
      return Object.assign({},
        this.$listeners,
        {
          input: function (event) {
            vm.$emit('input', event.target.value)
          }
        }
      )
    }
  }
}
</script>

<style scoped>
.app-textarea {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: var(--app-font-size-base, 1rem);
  font-weight: 400;
  line-height: var(--app-line-height, 1.5);
  color: var(--app-text-color, #495057);
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid var(--app-border-color, #ced4da);
  border-radius: var(--app-border-radius, 0.25rem);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  min-height: 80px;
  resize: vertical;
}
.app-textarea:focus {
  color: var(--app-text-color, #495057);
  background-color: #fff;
  border-color: var(--app-primary);
  outline: 0;
  box-shadow: 0 0 0 0.2rem var(--app-primary-focus, rgba(15, 40, 53, 0.25));
}
.app-textarea:disabled, .app-textarea[readonly] {
  background-color: #e9ecef;
  opacity: 1;
}
</style>
